import * as React from "react";
import { MenuItem } from "components/bootstrap";
const AssetOrderedOptionsFilter = ({ attribute, allActiveFilters, filterValueRenderer, onSubmit }) => {
  var _a;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, ((_a = attribute.filter_options) != null ? _a : []).map(({ title, value }) => {
    var _a2;
    const disabled = !!((_a2 = allActiveFilters == null ? void 0 : allActiveFilters.get(attribute.id)) == null ? void 0 : _a2.find(({ value: filterValue }) => value === filterValue));
    return /* @__PURE__ */ React.createElement(MenuItem, { key: `filter-value-${value}`, disabled, onSelect: () => onSubmit({ value, title }) }, filterValueRenderer ? filterValueRenderer(value, title) : title);
  }));
};
export default AssetOrderedOptionsFilter;
